import styled from "@emotion/styled"
import Scrollspy from "react-scrollspy"

export const ContentWrapper = styled.section`
  width: 90vw;
  box-sizing: border-box;
  padding: 6rem 10vw 0 2rem;

  @media screen and (min-width: 1024px) {
    width: 80vw;
    padding: 10vw 10vw 0 25vw;
  }
`

export const ContentTitle = styled.h1`
  font-family: "Montserrat", sans-serif;
  transform: scale(1, 0.9);
  font-weight: 700;
  text-transform: lowercase;
  margin-bottom: 4vw;
  font-size: 2.5rem;
  letter-spacing: -0.05rem;
  line-height: 1;
  display: inline-block;
  position: relative;

  @media screen and (min-width: 1024px) {
    white-space: nowrap;
    font-size: 4vw;
    right: 23vw;
  }
`

export const ContentBody = styled.div`
  font-size: 1.125rem;
  line-height: 1.75;
  margin-bottom: 6rem;
  font-family: "Montserrat", sans-serif;

  h2 {
    font-family: "Yantramanav", sans-serif;
    font-weight: 700;
    font-size: 1.125rem;
    text-transform: uppercase;
    color: #2497c6;
    margin: 8rem 0 0 0;
    /* line-height: 1; */
    overflow: hidden;
    display: inline-block;

    @media screen and (min-width: 1024px) {
      position: relative;
      right: 23vw;
      max-width: 300px;

      &.visible {
        :after {
          transform: translateX(100%);
        }
      }

      :after {
        display: block;
        content: "";
        background-color: #2497c6;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        transition: all 0.8s ease-in-out;
        transform: translateX(0%);
      }
    }
  }

  video + h2 {
    @media (max-width: 1023px) {
      margin-top: 0;
    }
  }

  h3 {
    margin-top: 4rem;
    margin-bottom: 1rem;
    line-height: 1.25;
  }

  img,
  video {
    position: relative;
    right: 8vw;
    margin: 4rem 0;
    max-width: 75vw;
    min-width: 33vw;
    min-height: 150px;
    object-fit: cover;
    filter: saturate(0.5);
    transition: all 0.4s ease-in-out;

    @media screen and (min-width: 1024px) {
      min-height: 450px;
      right: 25vw;
    }

    &:hover {
      cursor: pointer;
      filter: saturate(1);
      transform: scale(1.0125) !important;
    }
  }

  a {
    color: #2497c6;
  }

  li {
    margin-bottom: 1rem;
  }
`

export const ContentIceberg = styled.p`
  position: fixed;
  right: 0;
  bottom: calc(0px - 0.5rem);
  line-height: 0;
  text-transform: lowercase;
  writing-mode: vertical-lr;
  font-family: "Montserrat", sans-serif;
  transform: scale(1, 0.9);
  font-weight: 700;
  font-size: 10vw;
  white-space: nowrap;

  @media (min-width: 1024px) {
    bottom: auto;
    top: 67%;
  }
`

export const ContentSidebar = styled(Scrollspy)`
  z-index: 10;
  position: fixed;
  bottom: calc(33% + 2rem);
  list-style: none;
  padding-left: 0;
  transform: translateX(-100%);

  @media (max-width: 1023px) {
    display: none;
  }
`

export const ContentSidebarItem = styled.li`
  margin-bottom: 1rem;
  text-align: center;
  font-family: "Montserrat", sans-serif;transform: scale(1, 0.9);
  font-weight: 700;
  font-size: 1rem;
  transition: all 0.4s ease-in-out;
  position: relative;

  &.is-current {
    a {
       color: #2497c6;
    }
  }

  a {
    color: #1e1e1e;
    text-decoration: none;
  }

  :hover {
    cursor: pointer;
    
    a {
      color: #2497c6;
    }

    ::after {
      opacity: 1;
      transform: translate(-3rem, -50%);
    }
  }
  

  ::after {
    content: '${props => props.after}';
    display: block;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(-100%, -50%);
    font-size: .875rem;
    white-space: nowrap;
    opacity: 0;
    transition: all .4s ease-in-out;
    padding: .5rem 1rem;
    color: #fefefe;
    background: #2497c6;
    pointer-events: none;
  }
`
